 
// actions/zoning.actions.ts
export const storeFareMediaInfo = (fareMediaInfo) => ({
	  type: "storeFareMediaInfo",
	  payload: fareMediaInfo // Use "payload" instead of "data"
	});